import React, {useState, useEffect} from 'react'
import Header from 'components/Headers/Header';
import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    Button,
    Row,
    Col,
    CardImg,
    Media,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Badge
} from "reactstrap";
import Swal from 'sweetalert2'
import { connect, useDispatch } from 'react-redux';
import { fetchDatCourses, deleteDatCourse, deleteDatCourseReset } from 'redux/ManageDatCourses/ManageDatCoursesActions'
import { fetchPaymentRecord } from 'redux/Payments/PaymentsActions';
import DatCoursesLessons from 'components/Pages/DatCoursesLessons';
import Paginate from 'components/Pagination/DatCoursesPagination';
import CourseItemList from 'components/Courses/CourseItemList';
import { studentsLifetimePlan } from "util/DataList";
import { useHistory } from 'react-router-dom';
const DatCourses = (props) => {

     const addZeroes = num => num.toLocaleString("en",{minimumFractionDigits: 2})

    const [modalAddDatCourseModal, setModalAddDatCourseModal] = useState(false);
    const [initialCourseList, setInitialCourseList] = useState([]);
    const [datCoursesLists, setDatCoursesLists] = useState([]);

    const [datPaymentRecord,setDatPaymentRecord] = useState([]);
    const [startCourseData, setStartCourseData] = useState({});

    const history = useHistory();
    
    const toggleAddDatCourseModal = () =>{
        
        setModalAddDatCourseModal(!modalAddDatCourseModal);
        
    } 

    const dispatch = useDispatch()
    
    useEffect(() => {
        
        dispatch(fetchPaymentRecord({table: 'datCourses', user: props.userDetails.handle}))
        dispatch(fetchDatCourses({visibility: "published", subject: props.subject }))
        fetchSubscriptionDetails()
    }, [])
    
    useEffect(() => {
        
        if(props.fetchDatCourses.datcourses.length){
            
            setInitialCourseList(props.fetchDatCourses.datcourses)
            // const res = props.fetchDatCourses.datcourses.map((obj,i) => ({
            //     ...obj,
            //     payment: checkIfPaid(obj.datCourseId)
               
            // }))
            // setInitialCourseList(res)
        }
        else{
            setInitialCourseList([])
        }
        
    }, [props.fetchDatCourses ])

    useEffect(() => {
        if(props.fetchPaymentRecord.fetchpaymentrecord.length){
            setDatPaymentRecord(props.fetchPaymentRecord.fetchpaymentrecord[0])

            setStartCourseData({})

        }
    }, [props.fetchPaymentRecord ])

    useEffect(() => {
        if(initialCourseList){
            let collectData = []
            
            initialCourseList.map((obj,i) => {
                for (let i = 0; i < datPaymentRecord.length; i++) {
                    if(obj.datCourseId == datPaymentRecord[i].collectionDocId){
                        obj.payment = datPaymentRecord[i]
                    }
                    
                }
                collectData.push(obj)
            })
           setDatCoursesLists(collectData)


        }
    }, [datPaymentRecord, initialCourseList])

    useEffect(() => {
      
      
        // if(courseSelected != ''){
        //     setStartCourseData(datCoursesLists.find(item => item.datCourseId === courseSelected))
        // }

        if(datCoursesLists.length > 0){
            setStartCourseData(datCoursesLists[0])
        }else{
            setStartCourseData({})
        }
      
    }, [datCoursesLists])
    

    // const checkIfPaid = (cid) => {
    //     const result = []
    //     if(datPaymentRecord.length > 0){
    //         datPaymentRecord.map((pay,i) => (
    //             pay ?  cid == pay.collectionDocId ? result.push(pay) : "" : ""
                
    //         ))
    //     }
    //     console.log(result)
    //     return result        
    // }

    
    
    const [courseSelected, setCourseSelected] = useState('')

    const handleCourseItemCallback =  (course) => {
        const lessonCount = typeof course.category != "undefined" ? course.category.reduce((totalPublishedLessons, category) =>
        totalPublishedLessons + (category.lessons && category.lessons.filter(lesson => lesson.visibility === "published").length),
            0
        ): 0
        
        if(lessonCount == 0){
            Swal.fire({
                title:'Sorry!',
                text:'This course currently has no lessons.',
                icon :'warning',
                timer: 3000
                
              }
            )
        }
        else{
            setStartCourseData(course)
            setCourseSelected(course.datCourseId);
        }
       
    };

     const handleShowCourseItem =  (e,course) => {
      
        const lessonCount = typeof course.category != "undefined" ? course.category.reduce((totalPublishedLessons, category) =>
        totalPublishedLessons + (category.lessons && category.lessons.filter(lesson => lesson.visibility === "published").length),
            0
        ): 0
        
        if(lessonCount == 0){
            Swal.fire({
                title:'Sorry!',
                text:'This course currently has no lessons.',
                icon :'warning',
                timer: 3000
                
              }
            )
        }
        else{
            setStartCourseData(course)
        }
       
    };

    const handleBackToDatCourses = (e) => {
        e.preventDefault()
        setStartCourseData({})
    }

    const [subscribe, setSubscribe] = useState('lock');
    const [ultimateSubscribe, setUltimateSubscribe] = useState('lock');
    const fetchSubscriptionDetails = () => {
        // if(props.userDetails.ultimateAdvisingStudent == true || props.userDetails.ultimateAdvisingStudent == "true" || studentsLifetimePlan.includes(props.userDetails.email)){
        if(props.userDetails.ultimateAdvisingStudent == true || props.userDetails.ultimateAdvisingStudent == "true"){
            // setSubscribe('unlock')
            setUltimateSubscribe('unlock')
        }
        else{   
            if(props.fetchDetailsSubscription.fetchdetailssubscription.length){

                const subsDetails = props.fetchDetailsSubscription.fetchdetailssubscription[0]

                if(subsDetails.status == "active" || subsDetails.status == "trialing"){
                    setSubscribe('unlock')
                }
                else{

                    const date = new Date();
                    const secondsSinceEpoch = Math.floor(date.getTime() / 1000);
                    
                    if(subsDetails.cancel_at_period_end){
                        if(secondsSinceEpoch > subsDetails.canceled_at){
                            setSubscribe('lock')
                        }
                        else{
                            setSubscribe('unlock')
                        }
                    }
                    else{
                        setSubscribe('lock')
                    }
                
                }

            

            }
            else{
                setSubscribe('lock')
            }
        }
            
    }
    useEffect(() => {

        fetchSubscriptionDetails()
    
    }, [props.fetchDetailsSubscription])


    const [searchCourse, setSearchCourse] = useState("");
    const [searchedCourse, setSearchedCourse] = useState([]);

    const searchCourses = async (value) => {
        let search = await arraySearch(datCoursesLists, value);
        setSearchedCourse(search);
        setSearchCourse(value);
    };
    const arraySearch = (array, keyword) => {
        const searchTerm = keyword.toLowerCase();
        return array.filter((value) => {
            return (
                value.courseDescription.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.courseTitle.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.instructorName.toLowerCase().match(new RegExp(searchTerm, "g"))
            );
        });
    };


    const [currentPage, setCurrentPage] = useState(1);
	const [coursesPerPage] = useState(6);

    const indexOfLastPost = currentPage * coursesPerPage;
	const indexOfFirstPost = indexOfLastPost - coursesPerPage;
	const currentCourses = datCoursesLists.slice(indexOfFirstPost, indexOfLastPost);
    
    
	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const previousPage = () => {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const nextPage = () => {
		if (currentPage !== Math.ceil(datCoursesLists.length / coursesPerPage)) {
			setCurrentPage(currentPage + 1);
		}
	};    

    return (
        <Container className="mt-4" fluid>
            {
                Object.keys(startCourseData).length === 0? <>
                    <h3>No course data available</h3>
                </> : <>
                    <DatCoursesLessons 
                        key={startCourseData.datCourseId} 
                        courseData={startCourseData} 
                        bgColor={props.bgColor} 
                        textColor={props.textColor}
                    />
                </>
                }
        </Container>
    )
    
    // return (
    //     <>
            
    //          <div className={"header "+props.bgColor+" pb-5 pt-5  rounded"}>
                
    //             <Container className="" fluid>
    //                 <Row>
    //                     <Col lg="8" md="11">
    //                     {Object.keys(startCourseData).length !== 0 ?<>
    //                         <h1 className="display-2 text-white mb-4 lh-100 font-weight-bolder">{startCourseData.courseTitle}</h1>
                            
    //                         <Button className="shadow" color="default" onClick={(e) => handleBackToDatCourses(e)}><i className="fas fa-arrow-left"></i>&nbsp;&nbsp;Back to Courses</Button>
    //                         </>
    //                      : <><br></br><br></br><br></br></> }
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </div>
    //         {Object.keys(startCourseData).length === 0? <>
            
            
            
           
    //         <Container className="mt--8" >
    //             <Row >
    //                 <Col lg="12">
    //                     <FormGroup>
    //                         <InputGroup className="mb-4 input-group-lg shadow">
    //                             <InputGroupAddon addonType="prepend">
    //                             <InputGroupText>
    //                                 <i className="fas fa-search" />
    //                             </InputGroupText>
    //                             </InputGroupAddon>
    //                             <Input
    //                                 placeholder="Search.."
    //                                 type="text"
    //                                 className='pl-3'
    //                                 value={searchCourse}
    //                                 onChange={(e) => searchCourses(e.target.value)}
    //                             />
    //                         </InputGroup>
    //                     </FormGroup>
    //                 </Col>
                  
    //             </Row>
               
    //             <Row>
    //                 <Col lg="12" md="12" className='mt-3'>
    //                 { 
    //                     searchCourse ? 
    //                         searchedCourse.length ? 
    //                         <Row>
                                
    //                             {
    //                                 searchedCourse.map((c, i) => {
    //                                     return (<Col xl="6" lg="6" md="12" sm="12" className="d-flex flex-column flex-wrap"><CourseItemList datCourse={true} key={c.datCourseId} item={c} courseCallback={handleCourseItemCallback} /></Col>)
    //                                 })
    //                             }
                                
                                
    //                             <Col xl="12" lg="12">
    //                                 {
    //                                 searchedCourse.length > coursesPerPage ?
    //                                     <div className="d-flex justify-content-center mt-3">
    //                                         <Paginate
    //                                             itemPerPage={coursesPerPage}
    //                                             totalItems={searchedCourse.length}
    //                                             currentPage={currentPage}
    //                                             paginate={paginate}
    //                                             previousPage={previousPage}
    //                                             nextPage={nextPage}
    //                                         />
    //                                     </div>
    //                                 : ""

    //                                 }
                                    
    //                             </Col>
    //                         </Row>

                                
                                
    //                         : <p className='text-center font-weight-bolder text-dark'>No Result</p>  
    //                     : 
    //                      <>
                        
    //                         { !datCoursesLists.length ? 
    //                             <Card className='shadow'>
    //                                 <CardBody className='text-center'>
    //                                     <h2 className='mb-0'>No courses listed.</h2>
    //                                 </CardBody>
    //                             </Card>
    //                             :
    //                             <Row>   
    //                                 {

    //                                     currentCourses.map((c, i) => (
                                        
    //                                         <Col xl="6" lg="6" md="12" sm="12" className="d-flex flex-column flex-wrap"><CourseItemList datCourse={true} key={c.datCourseId} item={c} courseCallback={handleCourseItemCallback} /></Col>
                                            
                                            
    //                                     ))
    //                                 }
    //                                 <Col xl="12" lg="12">
    //                                 {
    //                                     datCoursesLists.length > coursesPerPage ?
    //                                     <div className="d-flex justify-content-center mt-3">
    //                                         <Paginate
    //                                             itemPerPage={coursesPerPage}
    //                                             totalItems={datCoursesLists.length}
    //                                             currentPage={currentPage}
    //                                             paginate={paginate}
    //                                             previousPage={previousPage}
    //                                             nextPage={nextPage}
    //                                         />
    //                                     </div>
    //                                     :""
    //                                 }
    //                                 </Col>
    //                             </Row>
    //                         } 
                       
                      
                        

    //                     </>
                      
                        
                            
                            
                              
                            


                   
    //                 }

    //                 </Col> 
                    
    //             </Row>
                
    //         </Container>
    //         </>
    //         : <Container className="mt-4" fluid><DatCoursesLessons courseData={startCourseData} bgColor={props.bgColor} textColor={props.textColor}></DatCoursesLessons></Container>}
            
        
    //     </>
    // )
}

const mapStateToProps = state  => {
    return {
        userDetails : state.loginAuth.userDetails,
        fetchDatCourses : state.fetchDatCourses,
        createDatCourse : state.createDatCourse,
        updateDatCourse : state.updateDatCourse,
        deleteDatCourse : state.deleteDatCourse,
        fetchDetailsSubscription : state.fetchDetailsSubscription,
        fetchPaymentRecord: state.fetchPaymentRecord,
        adminUser : state.adminUser
    }
      
}

export default connect(mapStateToProps)(DatCourses)
